module.exports = __webpack_public_path__ + "img/traffic_truck.4a1b87dc.png";